import * as types from './mutation-types'
import Vue from 'vue'
import { ICoverageIterationState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbCoverageIteration, IAloDbCoverageIterationConstParam } from '@/models/alodb/AloDbCoverageIteration';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'
import { calculAllDomainsData } from '@/models/alo/AloMission';

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<ICoverageIterationState> = {
     
    //Gestion des recherches de missions
    [types.COVERAGEITERATION_REQUEST]: state => {
        state.status = 'loading coverageIterations'
        state.coverageIterationLoading = true
    },
    [types.COVERAGEITERATION_SUCCESS]: (state, coverageIterations:Array<AloDbCoverageIteration>) => {
        state.status = 'success loading coverageIterations'
        state.coverageIterations = coverageIterations   
        state.coverageIterationLoading = false             
    },
    [types.COVERAGEITERATION_ERROR]: state => {
        state.status = 'error loading coverageIterations'
        state.coverageIterations = []
        state.coverageIterationLoading = false
    },
    [types.COVERAGEITERATION_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = `loading coverageIteration ${itemId}`
        state.coverageIterationLoading = true
    },
    [types.COVERAGEITERATION_SELECT_DETAIL_ERROR]: state => {
        state.status = 'error loading coverageIteration'
        state.coverageIterationLoading = false
    },
    [types.COVERAGEITERATION_SELECT_DETAIL_SUCCESS]: (state,coverageIteration:AloDbCoverageIteration) => {
        state.status = `success loading coverageIteration ${coverageIteration.COV_ID}`                
        //1, on met à jour de m'coverageIteration dans la liste des coverageIterations
        const index = state.coverageIterations.findIndex(m => m.COV_ID == coverageIteration.COV_ID)      
        state.coverageIterations.splice(index == -1 ? state.coverageIterations.length : index, index == -1 ? 0 : 1, coverageIteration)
        state.coverageIterationLoading = false
    },
    [types.COVERAGEITERATION_SELECT_DETAIL]: (state,coverageIteration:AloDbCoverageIteration) => {                
        state.originalAdmCoverageIteration = coverageIteration        
        state.modifiedAdmCoverageIteration = new AloDbCoverageIteration({...coverageIteration,COV_DATEXEC:coverageIteration.COV_DATEXEC?coverageIteration.COV_DATEXEC.toUTCString():null} as IAloDbCoverageIterationConstParam )
    },
    [types.COVERAGEITERATION_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = `sauvegarde coverageIteration ${libelle}`
        state.coverageIterationLoading = true
    },
    [types.COVERAGEITERATION_SAVE_ERROR]: state => {
        state.status = 'error sauvegarde coverageIteration'
        state.coverageIterationLoading = false
    },
    [types.COVERAGEITERATION_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmCoverageIteration = {...state.modifiedAdmCoverageIteration,...newProperties}
    },
    [types.COVERAGEITERATION_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.COVERAGEITERATION_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${libelle}`}).toString()        
        state.coverageIterationLoading = true
    },
    [types.COVERAGEITERATION_DELETE_SUCCESS]: (state,misId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${misId}`}).toString()
        const index = state.coverageIterations.findIndex(l => l.id == misId)
        state.coverageIterations.splice(index == -1 ? state.coverageIterations.length : index, index == -1 ? 0 : 1)
        state.coverageIterationLoading = false
    },
    [types.COVERAGEITERATION_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.coverageIterationLoading = false
    },        
    [types.COVERAGEITERATION_DATA_SCIENCE_REQUEST]: (state, {id,gliderKey}:{id:number,gliderKey:string}) => {
        state.status = `loading science data for coverage iteation ${id} ${gliderKey}`
        const index = state.coverageIterations.findIndex(m => m.id == id)
        if (index > -1) {
            const mission = state.coverageIterations?.[index]?.resultAloMission?.[gliderKey]
            if(mission) mission._dataScienceLoading = true
        }
    },
    [types.COVERAGEITERATION_DATA_SCIENCE_SUCCESS]: (state, { id,gliderKey, datas, targetYosCycles }:{ id:number,gliderKey:string, datas:any, targetYosCycles:Array<number>|null }) => {
        state.status = `success loading science data for coverage iteration ${id} ${gliderKey}`
        
        //Mise à jour des données sciences de la mission
        const index = state.coverageIterations.findIndex(m => m.id == id)
        if (index > -1) {
            const mission = state.coverageIterations?.[index]?.resultAloMission?.[gliderKey]    
            if(mission){                
                //Si la mission a deja des données sciences on est dans le cas d'une mise à jour ou d'un ajout
                if(targetYosCycles && (mission?.dataScience?.length ?? 0) > 0){
                    //const yosCycles = extractDistinctNumberProp(datas,d => d.yosCycle)
                    datas = [...mission.dataScience.filter(d => targetYosCycles.every(y => y != d.yosCycle)),...datas].sort((a,b) => a.PLD_REALTIMECLOCK.getTime() - b.PLD_REALTIMECLOCK.getTime())
                }      
                
                calculAllDomainsData(
                    mission.sciPlotVariables,
                    mission.xSciScatterVariable,
                    mission.domains,
                    mission.domainsAutoScale,
                    mission.domainsColor,
                    datas
                )            
                mission.dataScience = datas
                mission._dataScienceLoaded = true            
                mission._dataScienceLoading = false   
            }
        }
    },
    [types.COVERAGEITERATION_DATA_SCIENCE_ERROR]: (state, {id,gliderKey}:{id:number,gliderKey:string}) => {
        state.status = `error loading science data for coverage iteration ${id} ${gliderKey}`
        const index = state.coverageIterations.findIndex(m => m.id == id)
        if (index > -1) {
            const mission = state.coverageIterations?.[index]?.resultAloMission?.[gliderKey]
            if(mission) mission._dataScienceLoading = false   
        }
    }       
}


export default mutations